import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui";

import { Budget } from "@/types";

import { FormCreateBudget } from "./form-create-budget";
import { FormUpdateBudget } from "./form-update-budget";

type FormBudgetsProps = {
  children: React.ReactNode;
  budget?: Budget;
  patientId?: string;
};

export function FormBudgets({ children, budget, patientId }: FormBudgetsProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Drawer open={open} onOpenChange={setOpen} dismissible={false}>
      <DrawerTrigger asChild>{children}</DrawerTrigger>
      <DrawerContent className="h-[94vh] p-4" showButtonClose={false}>
        <DrawerHeader className="flex-none px-0">
          <DrawerTitle className="text-teal-700 font-bold">
            {t("LABEL.budget")}
          </DrawerTitle>
          <DrawerDescription>
            Preencha os campos para poder fazer o orçamento
          </DrawerDescription>
        </DrawerHeader>
        {budget ? (
          <FormUpdateBudget
            budget={budget}
            handleClose={() => setOpen(false)}
            patientId={patientId}
          />
        ) : (
          <FormCreateBudget patientId={patientId} handleClose={() => setOpen(false)} />
        )}
      </DrawerContent>
    </Drawer>
  );
}
